export type Nullable<T> = {
    [P in keyof T]?: T[P] | null;
};

export type ErrorResponse = {
    error: {
        code: number,
        message: {[key: string]: Array<string>}
    }
}

export type SuccessResponse = {
    success: boolean,
}

export type CookieOptions = {
    path?: string,
    expires? : string|number|Date
}

export type ClinicsPlace = {
    id: number,
    latitude: string,
    longitude: string,
    name: string,
    address: string,
    phone: string,
    site: string,
    image: string,
    imageDefault: string,
    type: number,
}

export type ClinicsListResponse = {
    items: Nullable<ClinicsPlace>[],
    count: number,
}

export type EventsDatesResponse = {
    response: {
        items: string[]
    }
}

export type EventsDatesRequest = {
    dateFrom: string;
    dateTo: string | null;
}

export type PaginationResponse = {
    response: {
        "currentPage": number,
        "lastPage": number,
        "perPage": number,
        "from": number,
        "to": number,
        "total": number,
        "html": {
            "items": string;
            "pagination": string;
        }
    }
}

export enum ScrollDirectionEnum {
    UP = "UP",
    DOWN = "DOWN"
}
